import * as endpoints from '@App/constants/endpoints';
import interceptor from '../interceptor';
import { get, post } from '../util';
import * as util from '@Util/';

const REPORTS = 'reports';
const AGENT = 'agent';
const SESSION = 'session';
const GENERATE = 'generate';
const AI = 'ai';


export const finishReportSession = async ({ header, params, sessionId }) => {
  const pathUrl = `${endpoints.API_FORMS}/${AGENT}/${REPORTS}/${SESSION}/${sessionId}/finish`;
  const axios = interceptor(header);
  return await post(axios, pathUrl, params);
};

export const getFormsList = async ({ header, params }) => {
  const pathUrl = `${endpoints.API_FORMS}/models/list`;
  const axios = interceptor(header);
  return await get(axios, pathUrl, params);
};

export const generateReportUnified = async ({ header, params }) => {
  const pathUrl = `${endpoints.API_FORMS}/${AI}/${REPORTS}/${GENERATE}`;
  const axios = interceptor(header);
  return await post(axios, pathUrl, params);
};

export const connectReportWebSocket = async ({ sessionId, header, onMessage, onError, onClose }) => {
  const auth = JSON.parse(util.getCookie('auth') || '{}');
  
  const wsUrl = endpoints.API_REPORT_GENERATOR_WEBSOCKET;
  
  try {
    let token = auth?.token || header?.token || '';
    let account = header?.account || header?.accountId || '';
    let workspace = header?.workspace || header?.workspaceId || '';
    let userId = header?.userId || '';
    
    let lang = navigator.language || navigator.userLanguage;
    if (auth && auth.languageCode) {
      lang = auth.languageCode;
    }
    if (lang) {
      lang = lang.startsWith('pt') ? lang : lang.split('-')[0];
    }

    const params = new URLSearchParams();
    params.append('sessionId', encodeURIComponent(sessionId));
    if (token) params.append('token', encodeURIComponent(`Bearer ${token}`));
    if (account) params.append('account', encodeURIComponent(account));
    if (workspace) params.append('workspace', encodeURIComponent(workspace));
    if (userId) params.append('userId', encodeURIComponent(userId));
    if (lang) params.append('lang', encodeURIComponent(lang));
    params.append('formOrigin', 2);

    const url = `${wsUrl}/ws/report-generator?${params.toString()}`;
    
    const ws = new WebSocket(url);

    ws.onmessage = (event) => {
      try {
        const message = JSON.parse(event.data);
        
        if (message.event !== 'heartbeat') {
          onMessage(message);
        }
      } catch (error) {
      }
    };

    ws.onerror = (error) => {
      if (onError) onError(error);
    };

    ws.onclose = () => {
      if (onClose) onClose();
    };

    return () => {
      if (ws.readyState === WebSocket.OPEN || ws.readyState === WebSocket.CONNECTING) {
        ws.close();
      }
    };

  } catch (error) {
    if (onError) onError(error);
    return () => {}; 
  }
};


